import {instance, baseUrl} from '../utils/request'
import AlertModule from 'vux/src/plugins/alert/module'


function fetch (type, url, parma) {
return instance({
method: type,
url: url,
data: parma
})
}   // 获取或提交数据

function promptMessage (txt, content, method) {
return AlertModule.show({
title: txt,
content: content,
onHide: method
})
}  // 提示框

export {fetch, promptMessage, baseUrl}



// WEBPACK FOOTER //
// ./src/api/dataHandling.js